import {Component, Input, OnInit} from '@angular/core';
import {faEdit, faEye, faPlus, faTrashAlt} from '@fortawesome/free-solid-svg-icons';

import {ToastrService} from 'ngx-toastr';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {StatesService} from '../../../shared/services/state/states.service';
import {MathsNaive} from '../../../shared/classes/maths/maths-naive';
import {MathsNaiveService} from '../../../shared/services/maths/maths-naive/maths-naive.service';
import {ModalService} from '../../../shared/services/modal/modal.service';

@Component({
  selector: 'app-maths-naive-crud',
  templateUrl: './maths-naive.component.html',
  styleUrls: ['./maths-naive.component.css']
})
export class MathsNaiveComponent implements OnInit {

  public faPlus = faPlus;
  public faEye = faEye;
  public faEdit = faEdit;
  public faTrashAlt = faTrashAlt;
  public showSpinner: boolean;
  public showSpinnerDelete: boolean;
  @Input('projectName') projectName = null;
  @Input('projectId') projectId = null;
  @Input('projectState') projectState = null;
  @Input('mode') mode = null;
  public readOnly: boolean = true;
  public mathsNaive: MathsNaive;
  public mathsNaiveForm: FormGroup;
  public mathsNaiveStaticForm: FormGroup;
  public mathsNaiveDynamicForm: FormGroup;

  public locationsPtForStaticParamsV5: any[] = [];
  public senHold: string;


  constructor(private modalService: ModalService,
              private toastr: ToastrService,
              public statesService: StatesService,
              private mathNaiveService: MathsNaiveService,
              private translate: TranslateService) {
  }


  ngOnInit() {
    this.readOnly = this.mode === 'read' ? true : false;

  }

  openModal(content) {

    this.mathsNaive = new MathsNaive(this.projectId);

    this.mathsNaiveForm = new FormGroup({
      dateStart: new FormControl(this.mathsNaive.dateStart, [Validators.required]),
      dateEnd: new FormControl(this.mathsNaive.dateEnd, [Validators.required])
    });

    this.mathsNaiveStaticForm = new FormGroup({
      doStatic: new FormControl(this.mathsNaive.doStatic, [Validators.required]),
      window_Size: new FormControl(this.mathsNaive.paramStatic.windowSize, [Validators.required]),
      noteMAX: new FormControl(this.mathsNaive.paramStatic.noteMAX, [Validators.required]),
      coefLT: new FormControl(this.mathsNaive.paramStatic.coefLT, [Validators.required]),
      coefCT: new FormControl(this.mathsNaive.paramStatic.coefCT, [Validators.required]),
      coefVF: new FormControl(this.mathsNaive.paramStatic.coefVF, [Validators.required]),
      refLT: new FormControl(this.mathsNaive.paramStatic.refLT, [Validators.required]),
      refCT: new FormControl(this.mathsNaive.paramStatic.refCT, [Validators.required]),

    });

    this.mathsNaiveDynamicForm = new FormGroup({
      doDynamic: new FormControl(this.mathsNaive.doDynamic, [Validators.required]),
      sampleInt: new FormControl(this.mathsNaive.paramDynamic.sampleInt, [Validators.required]),
      split_tg: new FormControl(this.mathsNaive.paramDynamic.split_tg, [Validators.required]),
      split_tr: new FormControl(this.mathsNaive.paramDynamic.split_tr, [Validators.required]),
      split_ts_val: new FormControl(this.mathsNaive.paramDynamic.split_ts_val, [Validators.required]),
      split_tr_val: new FormControl(this.mathsNaive.paramDynamic.split_tr_val, [Validators.required]),
      split_tr_sign: new FormControl(this.mathsNaive.paramDynamic.split_tr_sign, [Validators.required]),
      split_tr_pretrig: new FormControl(this.mathsNaive.paramDynamic.split_tr_pretrig, [Validators.required]),
      split_tr_postrig: new FormControl(this.mathsNaive.paramDynamic.split_tr_postrig, [Validators.required])
    });

    this.modalService.openNgbModal(content, {size: 'lg'});
    this.getProject();

  }

  getStaticState() {
    return this.mathsNaiveStaticForm.value.doStatic;
  }

  getDynamicState() {
    return this.mathsNaiveDynamicForm.value.doDynamic;
  }


  closeModal() {
    this.modalService.dismissAllNgbModals();
    this.mathsNaiveForm.reset();
    this.mathsNaiveStaticForm.reset();
    this.mathsNaiveDynamicForm.reset();

  }


  setDefEqualsPt(i: number, X: number) {
    this.mathsNaive.paramStaticV5.sensor_X[i] = X;
  }

  revokeMaths() {
    this.showSpinnerDelete = true;
    this.mathNaiveService.deleteSubscription(this.projectId).subscribe(() => {
      this.statesService.reloadListProject.next();
      this.toastr.warning(this.translate.instant('MATHS_DELETED'), this.translate.instant('SUCCESS'));
      this.showSpinnerDelete = false;
    });
  }

  public persistMaths() {

    if (this.mathsNaiveForm.valid && this.mathsNaiveStaticForm.valid && this.mathsNaiveDynamicForm.valid) {
      if (this.mathsHasChanged()) {
        this.showSpinner = true;
        this.setObjectWithFormValues();

        if (this.mode !== 'create') {
          this.mathNaiveService.patchSubscription(this.projectId, this.mathsNaive).subscribe((data: any) => {
            this.senHold = JSON.stringify(this.mathsNaive.paramStaticV5.sensor_X); // replace with setparams()
            this.statesService.reloadListProject.next();
            this.toastr.success(this.translate.instant('MATHS_MODIFIED'), this.translate.instant('SUCCESS'));
            this.showSpinner = false;
          });
        } else {

          this.mathNaiveService.postSubscription(this.mathsNaive).subscribe((data: any) => {
            this.setParams(data);
            this.statesService.reloadListProject.next();
            this.toastr.success(this.translate.instant('MATHS_CREATED'), this.translate.instant('SUCCESS'));
            this.showSpinner = false;
          });
        }
      } else {
        this.toastr.error(this.translate.instant('SAVING_DISABLED_MESSAGE'), this.translate.instant('ERROR'));
      }
    }
  };


  private getProject() {
    if (this.projectId !== null) {
      this.showSpinner = true;
      this.mathNaiveService.getProject(this.projectId, 'locations,maths')
        .subscribe((data: any) => {
          this.setPtList(data.project_device_locations);
          if (this.mode !== 'create') {
            this.setParams(data.project_params_abo_maths);
          } else {
            this.mathsNaive.paramStaticV5.sensor_Y = this.setDefList(data.project_device_locations);
          }
          this.showSpinner = false;
        });
    }
  }

  private setParams(data: any) {

    this.mathsNaive.setMathsNaive(data);

    this.senHold = JSON.stringify(this.mathsNaive.paramStaticV5.sensor_X);

    this.mathsNaiveForm.patchValue({
      dateStart: this.mathsNaive.dateStart,
      dateEnd: this.mathsNaive.dateEnd,
    });

    this.mathsNaiveStaticForm.patchValue({
      doStatic: this.mathsNaive.doStatic,
      window_Size: this.mathsNaive.paramStatic.windowSize,
      noteMAX: this.mathsNaive.paramStatic.noteMAX,
      coefLT: this.mathsNaive.paramStatic.coefLT,
      coefCT: this.mathsNaive.paramStatic.coefCT,
      coefVF: this.mathsNaive.paramStatic.coefVF,
      refLT: this.mathsNaive.paramStatic.refLT,
      refCT: this.mathsNaive.paramStatic.refCT,
    });

    this.mathsNaiveDynamicForm.patchValue({
      doDynamic: this.mathsNaive.doDynamic,
      sampleInt: this.mathsNaive.paramDynamic.sampleInt,
      split_tg: this.mathsNaive.paramDynamic.split_tg,
      split_tr: this.mathsNaive.paramDynamic.split_tr,
      split_ts_val: this.mathsNaive.paramDynamic.split_ts_val,
      split_tr_val: this.mathsNaive.paramDynamic.split_tr_val,
      split_tr_sign: this.mathsNaive.paramDynamic.split_tr_sign,
      split_tr_pretrig: this.mathsNaive.paramDynamic.split_tr_pretrig,
      split_tr_postrig: this.mathsNaive.paramDynamic.split_tr_postrig
    });

  }

  private setPtList(data: any) {
    this.locationsPtForStaticParamsV5 = [];
    data.forEach((loc) => {
      if (loc.device_type) {
        if (loc.device_type.id === 4) {
          this.locationsPtForStaticParamsV5.push(loc.id);
        }
      }

    });
  }

  private setDefList(data: any) {
    let locationsDefForStaticParamsV5 = [];
    data.forEach((loc) => {
      if (loc.device_type) {
        if (loc.device_type.id === 2 || loc.device_type.id === 3) {
          locationsDefForStaticParamsV5.push(loc.id);
        }
      }

    });
    return locationsDefForStaticParamsV5;
  }

  private setObjectWithFormValues() {
    this.mathsNaive.dateStart = this.mathsNaiveForm.value.dateStart;
    this.mathsNaive.dateEnd = this.mathsNaiveForm.value.dateEnd;

    this.mathsNaive.doStatic = this.mathsNaiveStaticForm.value.doStatic;
    this.mathsNaive.paramStatic.windowSize = this.mathsNaiveStaticForm.value.window_Size;
    this.mathsNaive.paramStatic.noteMAX = this.mathsNaiveStaticForm.value.noteMAX;
    this.mathsNaive.paramStatic.coefLT = this.mathsNaiveStaticForm.value.coefLT;
    this.mathsNaive.paramStatic.coefCT = this.mathsNaiveStaticForm.value.coefCT;
    this.mathsNaive.paramStatic.coefVF = this.mathsNaiveStaticForm.value.coefVF;
    this.mathsNaive.paramStatic.refLT = this.mathsNaiveStaticForm.value.refLT;
    this.mathsNaive.paramStatic.refCT = this.mathsNaiveStaticForm.value.refCT;

    this.mathsNaive.doDynamic = this.mathsNaiveDynamicForm.value.doDynamic;
    this.mathsNaive.paramDynamic.split_tg = this.mathsNaiveDynamicForm.value.split_tg;
    this.mathsNaive.paramDynamic.split_tr = this.mathsNaiveDynamicForm.value.split_tr;
    this.mathsNaive.paramDynamic.sampleInt = this.mathsNaiveDynamicForm.value.sampleInt;
    this.mathsNaive.paramDynamic.split_ts_val = this.mathsNaiveDynamicForm.value.split_ts_val;
    this.mathsNaive.paramDynamic.split_tr_val = this.mathsNaiveDynamicForm.value.split_tr_val;
    this.mathsNaive.paramDynamic.split_tr_sign = this.mathsNaiveDynamicForm.value.split_tr_sign;
    this.mathsNaive.paramDynamic.split_tr_pretrig = this.mathsNaiveDynamicForm.value.split_tr_pretrig;
    this.mathsNaive.paramDynamic.split_tr_postrig = this.mathsNaiveDynamicForm.value.split_tr_postrig;
  }

  private mathsHasChanged() {
    let changes = 0;

    changes = this.mathsNaive.dateStart !== this.mathsNaiveForm.value.dateStart ? changes + 1 : changes;
    changes = this.mathsNaive.dateEnd !== this.mathsNaiveForm.value.dateEnd ? changes + 1 : changes;

    changes = this.mathsNaive.doStatic !== this.mathsNaiveStaticForm.value.doStatic ? changes + 1 : changes;
    changes = this.mathsNaive.paramStatic.windowSize !== this.mathsNaiveStaticForm.value.window_Size ? changes + 1 : changes;
    changes = this.mathsNaive.paramStatic.noteMAX !== this.mathsNaiveStaticForm.value.noteMAX ? changes + 1 : changes;
    changes = this.mathsNaive.paramStatic.coefLT !== this.mathsNaiveStaticForm.value.coefLT ? changes + 1 : changes;
    changes = this.mathsNaive.paramStatic.coefCT !== this.mathsNaiveStaticForm.value.coefCT ? changes + 1 : changes;
    changes = this.mathsNaive.paramStatic.coefVF !== this.mathsNaiveStaticForm.value.coefVF ? changes + 1 : changes;
    changes = this.mathsNaive.paramStatic.refLT !== this.mathsNaiveStaticForm.value.refLT ? changes + 1 : changes;
    changes = this.mathsNaive.paramStatic.refCT !== this.mathsNaiveStaticForm.value.refCT ? changes + 1 : changes;

    changes = this.mathsNaive.doDynamic !== this.mathsNaiveDynamicForm.value.doDynamic ? changes + 1 : changes;
    changes = this.mathsNaive.paramDynamic.split_tg !== this.mathsNaiveDynamicForm.value.split_tg ? changes + 1 : changes;
    changes = this.mathsNaive.paramDynamic.split_tr !== this.mathsNaiveDynamicForm.value.split_tr ? changes + 1 : changes;
    changes = this.mathsNaive.paramDynamic.sampleInt !== this.mathsNaiveDynamicForm.value.sampleInt ? changes + 1 : changes;
    changes = this.mathsNaive.paramDynamic.split_ts_val !== this.mathsNaiveDynamicForm.value.split_ts_val ? changes + 1 : changes;
    changes = this.mathsNaive.paramDynamic.split_tr_val !== this.mathsNaiveDynamicForm.value.split_tr_val ? changes + 1 : changes;
    changes = this.mathsNaive.paramDynamic.split_tr_sign !== this.mathsNaiveDynamicForm.value.split_tr_sign ? changes + 1 : changes;
    changes = this.mathsNaive.paramDynamic.split_tr_pretrig !== this.mathsNaiveDynamicForm.value.split_tr_pretrig ? changes + 1 : changes;
    changes = this.mathsNaive.paramDynamic.split_tr_postrig !== this.mathsNaiveDynamicForm.value.split_tr_postrig ? changes + 1 : changes;

    changes = JSON.stringify(this.mathsNaive.paramStaticV5.sensor_X) !== this.senHold ? changes + 1 : changes;

    return changes > 0;

  }

}
